var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChevronRight = function SvgChevronRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.253822 14.7419C0.420504 14.9058 0.644484 14.9984 0.878274 15C1.11206 14.9984 1.33604 14.9058 1.50273 14.7419L8.13857 8.10814C8.3033 7.94206 8.39573 7.71761 8.39573 7.48368C8.39573 7.24976 8.3033 7.02531 8.13857 6.85923L1.50481 0.223392C1.33617 0.0735206 1.11664 -0.00625512 0.891121 0.000383421C0.665606 0.00702197 0.451149 0.0995731 0.291617 0.259105C0.132084 0.418638 0.0395331 0.633095 0.0328946 0.85861C0.026256 1.08413 0.106032 1.30366 0.255904 1.4723L6.26313 7.48368L0.253822 13.493C0.0910728 13.6601 0 13.8842 0 14.1174C0 14.3507 0.0910728 14.5748 0.253822 14.7419Z",
    fill: "#2443A7"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-right.8e8bf28b.svg";
export { ForwardRef as ReactComponent };